export const handleNumericChange = (e: any, setFieldValue: Function) => {
  setFieldValue(
    e.target.name,
    isNaN(parseInt(e.target.value)) ? null : parseInt(e.target.value),
  );
};
